module.exports = __webpack_public_path__ + "static/twokids-033dafbb468e5f24f849926a3b7a3fbc.svg";